export default {
    workOrder_workOrderTab_workOrderNumber: "Work Order Number",
    workOrder_workOrderTab_scheduledDate: "Scheduled Date",
    workOrder_workOrderTab_status: "Status",
    workOrder_workOrderTab_statusUpdatedOn: "Status Updated On",
    workOrder_workOrderTab_address: "Address",
    workOrder_workOrderTab_type: "Type",
    workOrder_workOrderTab_duration: "Duration (Mins)",
    workOrder_workOrderTab_severity: "Severity",
    workOrder_workOrderTab_viewAnswer: "View answer",
};